import { twMerge } from 'tailwind-merge'
import { Link } from 'react-router-dom'

import { stripMarkdown, formatShortTimestamp } from '@helpers/format'
import { getCourseVisualStyle } from '@helpers/courseUtils'
import Image from '@components/Image'

const CardWrapper = ({ className, currentTime, startDate, to, children }) => {
  return (
    <Choose>
      <When condition={!startDate || currentTime >= startDate}>
        <Link className={twMerge('h-full', className)} to={to}>
          {children}
        </Link>
      </When>

      <Otherwise>
        <div className={twMerge('h-full cursor-not-allowed', className)}>{children}</div>
      </Otherwise>
    </Choose>
  )
}

const CourseCard = ({ className, courseId, name, description, imageUrl, startDate, dueDate, currentTime }) => {
  const formattedDescription = stripMarkdown(description);
  const { emoji, gradientFrom, gradientTo } = getCourseVisualStyle(courseId);

  return (
    <CardWrapper className={className} currentTime={currentTime} startDate={startDate} to={`/students/courses/${courseId}`}>
      <div className="font-dm-sans grow border rounded-lg bg-background overflow-hidden h-full">
        <Choose>
          <When condition={imageUrl}>
            <Image
              className="w-full h-32 object-cover"
              src={imageUrl}
              placeholder={<div className="w-full h-32 bg-gray-200"></div>}
            />
          </When>
          <Otherwise>
            <div
              className="w-full h-32 flex items-center justify-center text-5xl"
              style={{ background: `linear-gradient(135deg, ${gradientFrom}, ${gradientTo})` }}
            >
              {emoji}
            </div>
          </Otherwise>
        </Choose>

        <div className="p-4">
          <h2 className="text-sm font-semibold line-clamp-1">{name}</h2>
          <p className="text-sm line-clamp-2 break-all">{formattedDescription}</p>

          <If condition={startDate && dueDate}>
            <div>
              <Choose>
                <When condition={startDate > currentTime}>
                  <p className="text-sm text-gray-500">
                    Available at {formatShortTimestamp(startDate)}
                  </p>
                </When>

                <When condition={currentTime >= startDate && dueDate > currentTime}>
                  <p className="text-sm text-green-600">
                    Available until {formatShortTimestamp(dueDate)}
                  </p>
                </When>

                <Otherwise>
                  <p className="text-sm text-gray-500">
                    Submissions closed
                  </p>
                </Otherwise>
              </Choose>
            </div>
          </If>
        </div>
      </div>
    </CardWrapper>
  )
}

export default CourseCard
